import { Link, useHistory } from 'react-router-dom'

import {
  Image,
  SpaceMember,
  SpaceMemberListOrderByEnum,
} from '@tribeplatform/gql-client/types'
import { useSpace, useSpaceMembers } from '@tribeplatform/react-sdk/hooks'
import { simplifyPaginatedResult } from '@tribeplatform/react-sdk/utils'
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'
import { Button } from '@tribeplatform/react-ui-kit/Button'

import { EmptyState } from './EmptyState'
import { LoadingState } from './LoadingState'
import { MembersBlockProps } from './types'

export const SpaceMemberList = ({
  limit,
  spaceId,
  roleIds,
  sort,
  showTagline,
  showViewAll,
}: Partial<MembersBlockProps>) => {
  let orderBy: SpaceMemberListOrderByEnum
  let reverse = false

  switch (sort) {
    case 'oldest-first':
      orderBy = SpaceMemberListOrderByEnum.CREATED_AT
      break
    // TODO not supported from backend
    // case 'alphabetical':
    // case 'number-of-posts':
    case 'newest-first':
    default:
      orderBy = SpaceMemberListOrderByEnum.CREATED_AT
      reverse = true
      break
  }

  const { data, isLoading, isFetched } = useSpaceMembers({
    fields: {
      member: { profilePicture: 'basic', role: 'basic' },
      role: 'basic',
    },
    variables: { limit, spaceId, orderBy, reverse, roleIds },
    useInfiniteQueryOptions: {
      enabled: !!spaceId,
    },
  })
  const { nodes: spaceMembers } = simplifyPaginatedResult<SpaceMember>(data)

  const { data: space } = useSpace({
    variables: { id: spaceId },
    useQueryOptions: {
      enabled: !!spaceId,
    },
  })
  const history = useHistory()

  const members = spaceMembers
    .filter(
      ({ role }) =>
        !roleIds || (roleIds?.length > 0 && roleIds.includes(role.id)),
    )
    .map(({ member }) => member)

  if (!isFetched || isLoading) {
    return <LoadingState count={limit} />
  }

  if (!members?.length) {
    return <EmptyState />
  }

  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 gap-1 -ms-2 -me-2">
        {members.map(member => {
          if (!member?.id) {
            return null
          }
          return (
            <Link
              key={member.id}
              to={member?.relativeUrl}
              className="group flex space-s-3 items-center p-2 rounded-md hover:bg-surface-hovered"
            >
              <Avatar
                size="md"
                src={(member?.profilePicture as Image)?.urls?.thumb}
                name={member?.name}
              />
              <div className="flex-grow max-w-full overflow-hidden">
                <div className="truncate text-content flex items-center">
                  {member?.name}
                </div>
                {showTagline && member?.tagline && (
                  <div className="text-base text-content-subdued truncate">
                    {member?.tagline}
                  </div>
                )}
              </div>
            </Link>
          )
        })}
      </div>
      {false && showViewAll && (
        <Button
          fullWidth
          variant="outline"
          onClick={() => {
            history.push(space?.relativeUrl)
          }}
        >
          View all
        </Button>
      )}
    </div>
  )
}
